import { render } from "./GroupListItem.vue?vue&type=template&id=63171982"
import script from "./GroupListItem.vue?vue&type=script&lang=js"
export * from "./GroupListItem.vue?vue&type=script&lang=js"

import "./GroupListItem.vue?vue&type=style&index=0&id=63171982&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__